import { computed, inject, Injectable } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { UserService } from './user.service';
import { Tags } from '@cardium/contracts';
import { UserApiService } from './user-api.service';

@Injectable({ providedIn: 'root' })
export class UserContextService {
  private readonly userService = inject(UserService);
  private readonly userApiService = inject(UserApiService);

  private readonly researchResource = rxResource({
    params: () => this.userService.user()?.id,
    stream: () => this.userApiService.getUserResearches(),
  });

  public readonly isRadiology = computed(() => {
    const researches = this.researchResource.value();
    if (!researches) return false;

    return !!researches.items?.every((research) =>
      research?.tags?.includes(Tags.RADIOLOGY),
    );
  });

  public readonly isInitialized = computed(() => {
    if (this.userService.isLoading()) return false;
    const user = this.userService.user();
    if (!user) return true;
    return !this.researchResource.isLoading();
  });
}
